<!-- Mobile Weekly Calendar Component -->
<!-- Matches Flutter's WeeklyCalendarWidgetMobileUI design with navigation arrows -->
<div class="mobile-weekly-calendar">
  <div class="calendar-row">
    <!-- Left arrow for previous week -->
    <button class="nav-arrow nav-arrow-left icon-mirror-rtl" (click)="onPreviousWeek($event)" [attr.aria-label]="ss.t('aria_previousWeek')" type="button">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 1L1 7L7 13" [attr.stroke]="theme.color12" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <!-- Week days -->
    <div class="week-row" [ngClass]="slideDirection()">
      @for (day of weekDays; track trackByDay($index, day); let i = $index) {
      <div class="day-column" (click)="onDayTap(day, $event)" role="button" tabindex="0"
        [attr.aria-label]="day.name + ' ' + day.date" [attr.aria-pressed]="day.active">

        <!-- Day label (S, M, T, etc.) - Use locale-aware narrow day name -->
        <span class="day-label" [style.color]="theme.color12" style="opacity: 0.7;">{{ day.narrowName }}</span>

        <!-- Date container -->
        <div class="date-container" [ngClass]="{
              'active': day.active,
              'today': day.isToday && !day.active
            }" [style.backgroundColor]="day.active ? theme.color15 : 'transparent'"
          [style.borderColor]="day.isToday && !day.active ? theme.color12 : 'transparent'">
          <span class="date-number" [ngClass]="{ 'active-text': day.active }"
            [style.color]="day.active ? theme.color2 : theme.color12">
            {{ day.date }}
          </span>
        </div>

        <!-- Event indicator dot - only takes space when dot is shown -->

        <div class="dot-container">
          @if (shouldShowDot(i, day)) {
          <div class="event-dot" [style.backgroundColor]="theme.color12">
          </div>
          }
        </div>

      </div>
      }
    </div>

    <!-- Right arrow for next week -->
    <button class="nav-arrow nav-arrow-right icon-mirror-rtl" (click)="onNextWeek($event)" [attr.aria-label]="ss.t('aria_nextWeek')" type="button">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L7 7L1 13" [attr.stroke]="theme.color12" stroke-width="1.5" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
  </div>
</div>